import React, { Component } from 'react';
import './App.css';

import ShortenUrl from './containers/ShortenUrl/ShortenUrl'

class App extends Component{
  render(){
    return (
      <div className="App">
        <header className="App-header">
          <h1>URL Shortner</h1>
        </header>
        <div>
          <ShortenUrl />
        </div>
      </div>
    );
  }
}

export default App;
